import {
  Box,
  Flex,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
  Image,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import scshield from "../images/SafeCraft_shield.png";

function AchievementsSection() {
  return (
    <Flex
      bg="rgba(248, 249, 250, 1)"
      p={8}
      borderRadius="lg"
      shadow="md"
      align="center"
      justify="center"
      gap="30%"
      direction={{ base: "column", lg: "row" }}
      marginBottom="168px"
      w={{ sm: "90%", "2xl": "50%" }}
      marginLeft="auto"
      marginRight="auto"
    >
      <Box flex="1" maxW="600px" p={4}>
        <Heading as="h2" size="lg" color="#C9342D" mb={6}>
          Premium paket Prilagodi e-učenje korporativnom identitetu
        </Heading>
        <Text>
          Snažan korporativni identitet uskladjuje vizuelno prisustvo kompanije
          sa njenim korporativnim vrednostima i kulturom, stvarajući dosledno
          iskustvo kako za kupce tako i za zaposlene.
        </Text>
        <List spacing={4} fontSize="lg" color="gray.700">
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#C9342D" />
            Menadžer naloga
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#C9342D" />
            Podešavanje SSO (Single Sign On) i organizacija korisnika
            centralizovano
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#C9342D" />
            Logo i brend klijenta
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#C9342D" />
            Prilagodjeni URL u formi subdomena klijent.safecrafts.rs
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#C9342D" />
            Prilagodjeni pozivni e-mailovi prema uobičajenoj korporativnoj
            komunikaciji
          </ListItem>
        </List>
      </Box>

      <Image src={scshield} alt="SafeCrafts logo" loading="lazy" />
    </Flex>
  );
}

export default AchievementsSection;
